<template>
  <div class="section section-concepts has-shadow">

    <div class="section-concepts--title">
      <h2>{{ $t("global.targetedClients") }}</h2>
    </div>
    
    <vue-tabs active-tab-color="#f4f4f4" type="pills" :start-index="1" direction="vertical">
      <v-tab v-for="task in whatWeDo" :key="task.id">
        <div slot="title" class="tab-title">
          <img :src="task.sub_title">
          <strong class="title title_center">{{ task.title }}</strong>
        </div>
        <div class="tab-content">
          <div class="row tab-content__row">
            <div class="col-md-6 col-md-offset-1 col-sm-6 col-sm-offset-1 col-xs-12 tab-content__desc">
              <h2 class="headline tab-content__desc__headline">{{ task.title }}</h2>
              <p class="tagline tab-content__desc__tagline">{{ task.content }}</p>
            </div>
            <div class="col-md-4 col-md-offset-1 col-sm-5 col-xs-12 col-xs-offset-0 tab-content__image">
              <object :id="task.id" type="image/svg+xml" width="200px" :data="task.image_url"></object>
            </div>
          </div>
        </div>
      </v-tab>
    </vue-tabs>
  </div>
</template>

<script>
import Vue from "vue";
import VueTabs from "vue-nav-tabs";

Vue.use(VueTabs);

export default {
	extends: VueTabs,
	name: "Skills",
	data() {
		return {
			whatWeDo: {}
		};
	},
	mounted() {
		this.getAll();
	},
	methods: {
		getAll() {
			this.$http
				.get(
					this.$parent.$parent.$parent.apiURL +
						"/textblocks/text-blocks-widgets?filter[name]=homepage-section-what-we-do"
				)
				.then(function(response) {
					this.whatWeDo = response.body.widget_blocks;
				});
		}
	}
};
</script>

<style scoped>
.tab-title {
	display: -webkit-flex;
	display: -moz-flex;
	display: -ms-flex;
	display: -o-flex;
	display: flex;
	align-items: center;
}
.section-concepts--title {
	margin-bottom: 40px;
}
.section-concepts--title .headline {
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/Skills.vue